import { computed, ReadonlySignal, Signal, signal } from '@preact/signals'
import type AppStore from './AppStore'

export enum ScannerMode {
  OneDRetail = '1dRetail',
  QR = 'qr',
  OneDIndustrial = '1dIndustrial',
  DPM = 'dpm',
  TwoDAll = '2dAll',
  All = 'all',
  SwissQR = 'swissQR',
  Batch = 'batch',
  LabelScanning = 'labelScanning',
  ExternalListBuilding = 'externalListBuilding',
  ExternalSearchAndFind = 'externalSearchAndFind',
}

export type TInitialOptionsStore = {
  scannerMode: Signal<ScannerMode | undefined>
  canStart: ReadonlySignal<boolean>
  launched: Signal<boolean>
  colorInvertedValue: Signal<boolean>
  colorInvertedEnabled: Signal<boolean>
  isSDKLoading: Signal<boolean>
  setScannerMode: (scannerModeType: ScannerMode) => void
  setColorInverted: (bool: boolean) => void
}

const InitialOptionsStore = (_: AppStore): TInitialOptionsStore => {
  const isSDKLoading = signal<boolean>(false)
  const scannerMode = signal<ScannerMode | undefined>(undefined)
  const canStart = computed(() => scannerMode.value !== undefined)
  const launched = signal(false)
  const colorInvertedValue = signal(false)
  const colorInvertedEnabled = computed(() => {
    if (
      scannerMode.value === ScannerMode.ExternalListBuilding ||
      scannerMode.value === ScannerMode.ExternalSearchAndFind ||
      scannerMode.value === ScannerMode.LabelScanning
    ) {
      colorInvertedValue.value = false
      return false
    }
    return true
  })

  const setScannerMode = async (scannerModeType: ScannerMode) => {
    scannerMode.value = scannerModeType
  }

  const setColorInverted = async (bool: boolean) => {
    colorInvertedValue.value = bool
  }

  return {
    scannerMode,
    canStart,
    launched,
    colorInvertedEnabled,
    colorInvertedValue,
    isSDKLoading,
    setScannerMode,
    setColorInverted,
  }
}

export default InitialOptionsStore
